import { render } from "./PaneOnlineType.vue?vue&type=template&id=281dc824&scoped=true&ts=true"
import script from "./PaneOnlineType.vue?vue&type=script&lang=ts"
export * from "./PaneOnlineType.vue?vue&type=script&lang=ts"

import "./PaneOnlineType.vue?vue&type=style&index=0&id=281dc824&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281dc824"]])

export default __exports__